import { render, staticRenderFns } from "./abroadTimetable.vue?vue&type=template&id=3063bf5f&scoped=true&"
import script from "./abroadTimetable.vue?vue&type=script&lang=js&"
export * from "./abroadTimetable.vue?vue&type=script&lang=js&"
import style0 from "./abroadTimetable.vue?vue&type=style&index=0&id=3063bf5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063bf5f",
  null
  
)

export default component.exports